/**
 * cmsUtils.ts — Shared, browser-safe CMS utility functions.
 *
 * These helpers have NO Node.js dependencies and can be safely
 * imported in both server and client components.
 */

/**
 * Returns the basePath configured in next.config.js.
 * Used to prefix URLs in raw <a> tags that don't auto-prepend basePath
 * like Next.js <Link> does.
 */
export const getAppBasePath = () => {
    return process.env.__NEXT_ROUTER_BASEPATH || '/showroom';
};

/**
 * Prepends the app basePath to a relative URL for use in raw <a> tags.
 * Next.js <Link> auto-prepends basePath, but raw <a> tags do not.
 * If the href already starts with basePath, it is returned as-is.
 *
 * @param href - The relative URL path (e.g. "/gtr/products/sofas")
 * @returns The path with basePath prefix (e.g. "/showroom/gtr/products/sofas")
 */
export const resolveHref = (href: string) => {
    if (!href || href === '#' || href.startsWith('http') || href.startsWith('mailto:')) return href;
    const basePath = getAppBasePath();
    if (href.startsWith(basePath)) return href;
    return `${basePath}${href.startsWith('/') ? '' : '/'}${href}`;
};

/**
 * Returns the URL path prefix for a given vendor.
 * For `nestingale` (the default brand), returns an empty string so that
 * URLs are simply `/product/...` rather than `/nestingale/product/...`.
 *
 * @param vendorName - The vendor/brand slug
 * @returns `"/${vendorName}"` or `""` for nestingale
 */
export const getBrandPathEntry = (vendorName: string) => {
    return `/showroom${vendorName && vendorName !== 'nestingale' ? '/' + vendorName : '/nestingale'}`;
};
